import './App.scss';
import { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import apolloClient from './config/apolloClient';
import { AuthProvider } from './context/AuthContext';
import Loading from './components/Loading';

// Components (loaded immediately)
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';

// Lazy-loaded Screens (loaded on demand)
const Landing = lazy(() => import('./screens/Landing'));
const Login = lazy(() => import('./screens/Login'));
const Register = lazy(() => import('./screens/Register'));
const Home = lazy(() => import('./screens/Home'));
const MovieDetail = lazy(() => import('./screens/MovieDetail'));
const Premium = lazy(() => import('./screens/Premium'));
const MyWatchlist = lazy(() => import('./screens/MyWatchlist'));
const Popular = lazy(() => import('./screens/Popular'));
const Exclusive = lazy(() => import('./screens/Exclusive'));

function App() {
  useEffect(() => {
    document.title = "Local Movie Theater";
  }, []);
  
  return (
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <Router>
          <div className="App">
            <Suspense fallback={<Loading />}>
              <Routes>
                {/* Ruta raíz - Landing page */}
                <Route path="/" element={<Landing />} />
                
                {/* Rutas públicas */}
                <Route 
                  path="/login" 
                  element={
                    <PublicRoute>
                      <Login />
                    </PublicRoute>
                  } 
                />
                <Route 
                  path="/register" 
                  element={
                    <PublicRoute>
                      <Register />
                    </PublicRoute>
                  } 
                />
                
                {/* Rutas protegidas */}
              <Route 
                path="/home" 
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/movie/:id" 
                element={
                  <ProtectedRoute>
                    <MovieDetail />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/premium" 
                element={
                  <ProtectedRoute>
                    <Premium />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/watchlist" 
                element={
                  <ProtectedRoute>
                    <MyWatchlist />
                  </ProtectedRoute>
                } 
                />
                <Route 
                  path="/popular" 
                  element={
                    <ProtectedRoute>
                      <Popular />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/exclusive" 
                  element={
                    <ProtectedRoute>
                      <Exclusive />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Ruta 404 */}
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </Suspense>
          </div>
        </Router>
      </AuthProvider>
    </ApolloProvider>
  );
}

export default App;
